module.exports = __webpack_public_path__ + "img/39.da771241.svg";